const MANAGE_USERS = "Manage Users - 247 Accessible Documents";
const ADD_NEW_USER = "Add New User - 247 Accessible Documents";
const UPDATE_USER = "Update User - 247 Accessible Documents";
const ADD_NEW_CUSTOM_USER = "Add New Custom User - 247 Accessible Documents";
const UPDATE_CUSTOM_USER = "Update Custom User - 247 Accessible Documents";
const ORDER_MANAGEMENT = "Order - 247 Accessible Documents";
const UPLOAD_TITLE = "Upload - 247 Accessible Documents";
const INVOICE_TITLE = "Invoice - 247 Accessible Documents";
const ORDER_DETAIL = (id) =>
  "Order Details " + id + " - 247 Accessible Documents";
const EDIT_PROFILE_TITLE = "Edit profile - 247 Accessible Documents";
const PROFILE_TITLE = "Profile - 247 Accessible Documents";
const SIGN_IN_TITLE = "Sign In - 247 Accessible Documents";
const REGISTER_TITLE = "Register - 247 Accessible Documents";
const FORGET_PASSWORD_TITLE = "Forget Password - 247 Accessible Documents";
const RESET_PASSWORD_TITLE = "Reset Password - 247 Accessible Documents";
const NOT_FOUND_TITLE = "Not Found - 247 Accessible Documents";
const DASHBOARD_TITLE = "Dashboard - 247 Accessible Documents";
const BILLINGS_TITLE = "Billing - 247 Accessible Documents";
const CLIENT_USERS_TITLE = "Client users - 247 Accessible Documents";
const CLIENT_ORDER_TITLE = "Client orders - 247 Accessible Documents";
const WORKLOAD_TITLE = "Workload - 247 Accessible Documents";
const USERS_FILE_DETAILS_TITLE = "UserFileDetails - 247 Accessible Documents";
const CREATE_PASSWORD_TITLE = "Create Password - 247 Accessible Documents";
const MANAGE_HOLIDAYS = "Manage Holidays - 247 Accessible Documents";
const ACCESSIBLE_INVOICE_TITLE = "Invoice - 247 Accessible Documents";
const REQUEST_APPROVALS_TITLE= "Request - 247 Accessible documents";

export {
  MANAGE_USERS,
  ADD_NEW_USER,
  UPDATE_USER,
  ORDER_MANAGEMENT,
  ORDER_DETAIL,
  UPLOAD_TITLE,
  INVOICE_TITLE,
  EDIT_PROFILE_TITLE,
  PROFILE_TITLE,
  SIGN_IN_TITLE,
  REGISTER_TITLE,
  FORGET_PASSWORD_TITLE,
  RESET_PASSWORD_TITLE,
  NOT_FOUND_TITLE,
  DASHBOARD_TITLE,
  BILLINGS_TITLE,
  CLIENT_USERS_TITLE,
  WORKLOAD_TITLE,
  USERS_FILE_DETAILS_TITLE,
  CREATE_PASSWORD_TITLE,
  MANAGE_HOLIDAYS,
  ADD_NEW_CUSTOM_USER,
  UPDATE_CUSTOM_USER,
  ACCESSIBLE_INVOICE_TITLE,
  REQUEST_APPROVALS_TITLE,
  CLIENT_ORDER_TITLE
};
